import { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { theme } from "../../App";
import { selectAvglength, selectExperiments, selectPieChart } from '../store/ExperimentSlice';
import { selectIssues } from '../store/IssuesSlice';
import ExpByWeeksGraph from "./entities/ExpByWeeksGraph";
import { PieChart } from "./entities/PieChart";

export function Synopsis() {
  const [expsByWeek, setExpsByWeek] = useState(null);
  const issues = useSelector(selectIssues)
  const experiments = useSelector(selectExperiments)
  const statusRatio = useSelector(selectPieChart)
  const aveExpLen = useSelector(selectAvglength)

  const calcExperimentsByWeek = (distanceBack = 10, minDist = 4) => {
    let experimentsByWeek = new Map();
    let week = new Date(Date.now());
    week.setDate(week.getDate() - week.getDay());
    // go back some distance and make categories
    for (let i = 0; i < distanceBack; i++) {
      let s = `${week.getMonth()}/${week.getDate()}/${week.getFullYear()}`;
      experimentsByWeek.set(s, 0);
      week.setDate(week.getDate() - 7);
    }

    // Add all the experiments to whichever week they belong to
    for (let ind in experiments) {
      let exp = experiments[ind];
      let d = new Date(exp.startDate);

      // week is just subtracting the day (wednesday = 4) from the date (13th)
      // so the 13th goes back to the week of 13 - 4 = Week of Sunday the 9th
      let weekString = `${d.getMonth()}/${d.getDate() - d.getDay()}/${d.getFullYear()}`;
      if (experimentsByWeek.get(weekString) === undefined) { continue; }
      let val = experimentsByWeek.get(weekString)
      experimentsByWeek.set(weekString, val + 1);
    }

    let keys = []; let values = [];
    experimentsByWeek.keys().forEach(
      (key) => { keys.push(key); values.push(experimentsByWeek.get(key)); }
    )

    return {
      categories: keys.reverse(),
      series: { name: 'Experiments', data: values.reverse(), color: theme.palette.primary.main }
    }
  }

  useEffect(() => {
    setExpsByWeek(calcExperimentsByWeek());
  }, [experiments, issues]);

  return (<>
    <div id="synopsis">
      <div className="synopsis-box">
        <h3 style={{ marginTop: 0 }}>Average Experiment Length</h3>
        <h1>{statusRatio ? aveExpLen : <p>Loading...</p>}</h1>
      </div>
      <div className="middle-synopsis-box">
        {statusRatio ? <PieChart name="Experiment Status" data={statusRatio} /> : <p>Loading...</p>}
      </div>
      <div className="synopsis-box">
        {expsByWeek ? <ExpByWeeksGraph name="Experiments By Week" data={expsByWeek} /> : <p>Loading...</p>}
      </div>
    </div>
  </>)
}